export default "__VITE_ASSET__D6rxOA7v__"